import type { SVGProps } from 'react';
const DawnFlagEC = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-EC_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-EC_svg__a)">
      <path fill="#0748AE" d="M0 11.733h22V7.467H0z" />
      <path fill="#DE2035" d="M0 16h22v-4.267H0z" />
      <path fill="#FFD935" d="M0 7.467h22V0H0z" />
      <path
        fill="#FFD935"
        d="M9.742 6.4a2.14 2.14 0 0 0-.838 1.707c0 1.178.938 2.133 2.095 2.133s2.096-.955 2.096-2.133c0-.698-.33-1.318-.838-1.707l-.734 2.24h-1.047z"
      />
      <path fill="#5FC0DC" d="m11 5.97.524 2.667h-1.047z" />
      <path
        fill="#3F2821"
        d="M9.846 3.951a.33.33 0 0 1 .345.082l.81.825.81-.825a.33.33 0 0 1 .344-.082l1.572.533a.333.333 0 1 1-.215.632L12.14 4.65l-.9.917a.333.333 0 0 1-.477 0l-.9-.917-1.374.466a.333.333 0 0 1-.214-.632z"
        opacity={0.66}
      />
    </g>
  </svg>
);
export default DawnFlagEC;
